(ns modal.views
  (:require
    [reagent.core :as r]
    [very.re-frame.core :as rf])
  (:require-macros
    [css.core :refer [defstyled]]
    [cljss.core :as cljss]))


(defn maybe-close-modal [evt])


(defstyled container :div
  {:display "flex"
   :position "fixed"
   :top 0
   :right 0
   :bottom 0
   :left 0
   :z-index 2})

(defstyled backdrop :div
  {:align-items "center"
   :background-color "rgba(0,0,0,.67)"
   :display "flex"
   :flex 1
   :justify-content "center"
   :z-index 2})

(defstyled content :div
  {:box-shadow "0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)"
   :background-color "white"
   :flex "0 0 auto"
   :overflow-y "auto"})

(defn modal-container []
  (let [state (rf/subscribe [:modal/state])]
    (fn []
      (when (:visible? @state)
        (r/with-let [_ (.addEventListener js/document "keydown" maybe-close-modal)]
          [container
           [backdrop
            [content
             [(:renderer @state)]]]]
          (finally
            (.removeEventListener js/document "keydown" maybe-close-modal)))))))
